import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BasePageComponent } from '../../../base-page';
import { Account } from '../../../../model/account.model';
import { ExchangeRate, IExchangeRate } from '../../../../model/exchange-rate.model';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { FormService } from '../../../../shared/services/form.service';
import { MatDialog } from '@angular/material/dialog';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { ExchangeRateService } from '../exchange-rate.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { TranslateService } from '@ngx-translate/core';
import { Url } from '../../../../shared/constant/url.constant';
import { ConstantHome } from '../../home/home.url';
import { ConstantExchangeRate } from '../exchange-rate.url';
import { takeUntil } from 'rxjs/operators';
import { CONSTANT_ICON } from '../../../../shared/constant/icon.constant';
import { ExchangeRateAddComponent } from '../add/exchange-rate-add.component';
import { ExchangeUpdateComponent } from '../update/exchange-rate-update.component';
import { BTN_CANCEL_CLASS, CANCEL_BG_COLOR } from '../../../../shared/constant/css-style/css-class.constant';
import { ColorService } from '../../../../shared/services/color.service';
import { ExchangeRateLiveAddComponent } from '../live/add/exchange-rate-live-add.component';
import { SIZE_H2_SM_POPUP, SIZE_H_MD_POPUP, SIZE_W_SM_POPUP } from '../../../../shared/constant/css-style/css-size.constant';
import { ExchangeRateHistoricalAddComponent } from './add/exchange-rate-historical-add.component';
import { VExchangeRateAddComponent } from '../../version-exch-rate/add/v-exchange-rate-add.component';

@Component({
  selector: 'app-exchange-rate-historical',
  templateUrl: './exchange-rate-historical.component.html'
})
export class ExchangeRateHistoricalComponent extends BasePageComponent implements OnInit,
  OnDestroy, AfterViewChecked {

  @ViewChild('basicTable') tabRef: any;
  account: Account; // the account connected.
  exchangeRateList: IExchangeRate[] = [];
  exchangeRateSearch: IExchangeRate[] = [];
  findExchangeRateList = true;

  searchValue: string;
  subs$ = new Subject<void>();
  dateTyped: any;

  constructor(
    private colorService: ColorService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private formService: FormService,
    private dialog: MatDialog,
    private accountService: AccountService,
    protected exchangeRateService: ExchangeRateService,
    store: Store<IAppState>, httpSv: HttpService,
    private translate : TranslateService) {
    super(store, httpSv);
    console.log('## construct exchange rate list historical');
    this.pageData = {
      title:'',
      key: 'listExchangeRateHistorical',
      // fil d'ariane.
      breadcrumbs: [
        {
          title: '',
          key: 'home',
          route: Url.SLASH_ROUTE.concat(ConstantHome.data.routing)
        },
        {
          title: '',
          key: 'exchangeRate',
          route: Url.SLASH_ROUTE.concat(ConstantExchangeRate.urlFull
            .EXCHANGE_RATE.HISTORICAL)
        },
        {
          title: '',
          key: 'lister'
        }
      ]
    };
    if(this.pageData.key==="listExchangeRateHistorical"){
      translate.get('listExchangeRateHistorical').subscribe(res => this.pageData.title=res);
    }
    this.pageData.breadcrumbs.forEach(value=> {
      if(value.key==="home"){
        translate.get('home').subscribe(res => value.title=res);
      }
      if( value.key==="exchangeRate" ){
        translate.get('exchangeRateHistorical').subscribe(res => value.title=res);
      }
      if( value.key==="lister" ){
        translate.get('lister').subscribe(res => value.title=res);
      }


    });
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  goToLive() {
    this.router.navigate([Url.SLASH_ROUTE.concat(ConstantExchangeRate.urlFull
      .EXCHANGE_RATE.LIVE)]);
  }

  ngOnInit(): void {
    console.log('## init exchange rate list Historical');
    super.ngOnInit();
    this.accountService.identity(false).pipe(takeUntil(this.subs$))
      .subscribe(account => {
        try {
          if (account) {
            super.setLoaded();
          }
          this.account = account;
        }catch (e) {
          console.log('## error identity:', e.message);
        }
      });
  }

  ngOnDestroy() {
    console.log('## on destroy exchange rate list live');
    super.ngOnDestroy();
    this.formService.free(this.subs$);
  }

  searchExchangeRate() {
    console.log('## search date: ' , this.dateTyped);
    this.getExchangeRateList(this.dateTyped);
  }

  goToDatabase() {
    this.router.navigate([Url.SLASH_ROUTE.concat(ConstantExchangeRate.urlFull
      .EXCHANGE_RATE.LIST)]);
  }

  getExchangeRateList(date: any) {
    this.findExchangeRateList = false;
    this.exchangeRateList = [];
    this.exchangeRateService.getExchangeRateHistorical(date).subscribe(res => {
      console.log('## Success get exchange rate list from Historical: ', res);
      const e: any = (res.quotes) ? res.quotes : [];
      console.log('## size: ', e.size);
      Object.keys(e).forEach((k: string) => {
        let ex = new ExchangeRate();
        ex.sourceMoney = res.source;
        ex.destMoney = k.slice(3);
        ex.resultExchange = e[k];
        this.exchangeRateList.push(ex);
      })
      this.findExchangeRateList = true;
      this.exchangeRateSearch = this.exchangeRateList;
      /*      this.exchangeRateService.getExchangeRateObs().pipe(takeUntil(this.subs$))
              .subscribe((res: IExchangeRate[]) => {
                console.log('## get list exchange rate in list by subject');
                const rs = res ? res : [];
                console.log('## size: ' + rs.length);
                this.exchangeRateList = rs;
                this.exchangeRateSearch = rs;
              });*/
    }, err => {
      this.findExchangeRateList = true;
      console.log('## error get exchange rate live: ', err);
    });
  }

  getTheadBg() {
    return this.colorService.getTheadBg();
  }

  getBgSearchBar() {
    return this.colorService.getBrdColorSearchBar();
  }

  getColorSearchBar() {
    return this.colorService.getColorSearchBar();
  }

  getCancelBgColor(): string {
    return CANCEL_BG_COLOR;
  }

  getBtnCancelClass(): string {
    return BTN_CANCEL_CLASS;
  }

  search() : void {
    const query = this.searchValue;
    console.log('## search: ' +query);
    const mapFn = (item) =>
      Object.values(item)
        .map(function(val){
          return val?.toString().toLowerCase();
        })
        .join(' ');
    const stringArr = [...this.exchangeRateSearch].map(mapFn);
    const result = this.exchangeRateSearch.filter(
      (_, i) => stringArr[i].indexOf(query && query.length ? query.toLowerCase() : '') > -1
    );
    this.exchangeRateList = [];
    result.forEach((c) => {
      this.exchangeRateList.push(c);
    })
  }

  hasFound(): boolean{
    return this.findExchangeRateList;
  }

  exchangeRateIsEmpty() {
    return this.exchangeRateList.length <= 0 || !this.exchangeRateList;
  }

  /* search(): void {
     const query = this.searchValue;
     console.log('## search: ' + query);
     const mapFn = (item) =>
       Object.values(item)
         .map(function(val) {
           return val?.toString().toLowerCase();
         })
         .join(' ');
     const stringArr = [...this.benefitSearch].map(mapFn);
     const result = this.benefitSearch.filter(
       (_, i) => stringArr[i].indexOf(query && query.length ? query.toLowerCase() : '') > -1
     );
     this.exchangeRateList = [];
     result.forEach((c) => {
       this.exchangeRateList.push(c);
     });
   }*/

  getIcon() {
    return CONSTANT_ICON;
  }

  /**
   * Ouvre le template html AccountsRessourceTypeAddComponent
   * dans un popup.
   */
  addNewVersion() {
    console.log('## open version exchange rate add');
    this.dialog.open(VExchangeRateAddComponent, {
      height: SIZE_H2_SM_POPUP,
      width: SIZE_W_SM_POPUP
    });
  }

  /**
   * Ouvre le template html AccountsRessourceTypeAddComponent
   * dans un popup.
   */
  add() {
    console.log('## open exchange rate historical add');
    this.dialog.open(ExchangeRateHistoricalAddComponent, {
      height: SIZE_H2_SM_POPUP,
      width: SIZE_H_MD_POPUP,
      data: this.dateTyped
    });
  }

  show(c: IExchangeRate) {
    /*console.log('## open service show');
    this.benefitService.setServiceItemSelectObs(c);
    this.dialog.open(MoniesShowComponent, {
      height: '700px',
      width: '800px',
    });*/
  }

  update(c: IExchangeRate) {
    this.exchangeRateService.setExchangeRateSelectObs(c);
    this.dialog.open(ExchangeUpdateComponent, {
      height: '700px',
      width: '800px',
    });
  }

  delete(c: IExchangeRate) {
    /*this.benefitService.setServiceItemSelectObs(c);
    this.dialog.open(ServiceItemDeleteComponent, {
      height: '700px',
      width: '800px',
    });*/
  }

  /**
   * Retourne la liste des services items
   * qui ont été stockés dans le selector 'nz-table'.
   */
  getList(): IExchangeRate[] {
    return (this.tabRef) ? this.tabRef.data : [];
  }

}
